export const updateCohortStatusAfterDeadline = function ($el, cohortTheme = 'default') {
  const oneWeekFromNow = Date.now() / 1000 + 60 * 60 * 24 * 7
  const deadline = Number($el.dataset.cohortEndDate)
  if (deadline == 0) {
    return false
  }

  const statusEl = $el.querySelector('.cohort-status')
  if (statusEl.innerHTML.trim() == 'Class is Full') {
    return
  }

  if (deadline < oneWeekFromNow) {
    const applyByEl = $el.querySelector('.cohort-apply-by')
    const statusEl = $el.querySelector('.cohort-status')
    if (cohortTheme == 'default') {
      applyByEl.classList.remove('open')
      applyByEl.classList.add('closing-soon')
      applyByEl.innerHTML = 'Closing soon'

      statusEl.classList.remove('open')
      statusEl.classList.add('closing-soon')
      statusEl.innerHTML = 'Closing soon'
    } else {
      statusEl.innerHTML = 'Closing soon'
      $el.querySelector('.cohort-status-color').classList.remove('bg-[#2F9B5B]')
      $el.querySelector('.cohort-status-color').classList.add('bg-[#F2994A]')
      $el.querySelector('.cohort-status-border').classList.add('border')
      $el.querySelector('.cohort-status-border').classList.add('border-[#F2994A]')
    }
  }
}